import { apiClient } from '../client'
import { FeatureFlagsResponse } from './types'

export const getFeatureFlags = async (): Promise<FeatureFlagsResponse> => {
    const response = await apiClient('v1/core/feature-flags')
    return response.data
}
